{
  "code": "EX-00",
  "APPOINTMENTS_VIEW": {
    "DETAIL_TAB": "Detalle de la visita",
    "EXTRA_INFO_TAB": "Novedades de información adicional",
    "ITEM_SAMPLE_TAB": "Entrega de muestras y POP",
    "STOCK_TAB": "Levantamiento de stock",
    "FACES_TAB": "Registro de caras - facing",
    "TRAINING_PERSON_TAB": "Contactos y stakeholders",
    "TRAINING_TAB": "Registro de capacitación",
    "DISPLAY_TAB": "Registro de exhibición",
    "PICTURE_TAB": "Constancia fotográfica visita",
    "HISTORY_TAB": "Histórico de visitas",
    "DYNAMIC_FORMS_TAB": "Encuestas",
    "CAMPAIGNS_TAB": "Parrilla promocional",
    "DETAILS_CAMPAIGN_TAB": "Detalle parrilla promocional",
    "STOCK_VISIBILITY": "Extra visibilidad",
    "STOCK_IS_SHOWN": "¿Perchado?",
    "SMART_SAMPLE_TITLE": "Smart Muestras P360°",
    "SMART_STOCK_TITLE": "Smart Stock P360°",
    "SMART_SAMPLE_DROPDOWN": "Tipo de muestra automático",
    "SMART_STOCK_DROPDOWN": "Tipo de stock automático"
  },
  "ORDERS_VIEW": {
    "DETAIL_TAB": "Detalle de los ítems solicitados",
    "PICTURE_TAB": "Constancia fotográfica pedido",
    "HISTORY_TAB": "Histórico de visitas"
  },
  "FORMS_AND_VALIDATIONS": {
    "COMMENTS_PLACEHOLDER": "Ingresa las observaciones",
    "COMMENTS_OF": "Observaciones de: {{value}}",
    "GENERAL_COMMENTS_PLACEHOLDER_WITH": "Ingresa las observaciones generales de {{value}}",
    "COMMENTS_WITH_PLACEHOLDER": "Ingresa las observaciones de {{value}}",
    "COMMITMENT_PLACEHOLDER": "Ingresa los compromisos efectuados",
    "CONTACT": "Contacto",
    "CONTACT_NAME_PLACEHOLDER": "Ingrese el nombre de contacto",
    "CONTACTS": "Contactos",
    "CONTACTS_PLACEHOLDER": "Seleccione el contacto",
    "FULLNAME": "Nombre completo (nombres y apellidos)",
    "FULLNAME_PLACEHOLDER": "Ingrese el nombre completo",
    "PERSON_TYPE": "Rol del contacto",
    "PERSON_TYPE_PLACEHOLDER": "Rol del contacto",
    "PERSON_INFLUENCE": "Nivel de influencia",
    "PERSON_INFLUENCE_PLACEHOLDER": "Nivel de influencia",
    "PERSON_TRAINEE": "Personas capacitadas",
    "CUSTOMER_PLACEHOLDER": "Empieza a escribir y selecciona un cliente",
    "CUSTOMER_NAME_PLACEHOLDER": "Ingrese el nombre del cliente",
    "DEPENDENT_NAME_PLACEHOLDER": "Ingrese el nombre de dependiente",
    "DISPATCHER_PLACEHOLDER": "Seleccione el despachador",
    "ITEM_PLACEHOLDER": "Seleccione el ítem",
    "TURN_NUMBER_PLACEHOLDER": "Ingresa el número del turno",
    "VIEWED_COMMENTS_PLACEHOLDER": "Ingresa las observaciones y retroalimentación del visitado",
    "ORDER_NUMBER": "Ref. Orden compra cliente",
    "ORDER_NUMBER_PLACEHOLDER": "Ingresa la ref. orden compra cliente",
    "DESCRIPTION_PLACEHOLDER": "Ingresa una descripción",
    "CAMPAIGN": "parrilla promocional",
    "PLANNING_VERSION_PLACEHOLDER": "Seleccione el fichero",

    "EMAIL_REQUIRED": "Debes ingresar tu correo electrónico.",
    "EMAIL_PLACEHOLDER": "Ingresa tu correo electrónico",
    "PASSWORD_REQUIRED": "Debes ingresar tu contraseña.",
    "PASSWORD_PLACEHOLDER": "Ingresa tu contraseña",

    "WORK_EMAIL_REQUIRED": "Debes ingresar tu correo electrónico empresarial.",
    "WORK_EMAIL_PLACEHOLDER": "Ingresa tu correo electrónico empresarial",
    "DOCUMENT_ID_REQUIRED": "Debes ingresar tu cédula de identidad.",
    "DOCUMENT_ID_PLACEHOLDER": "Ingresa tu cédula de identidad",
    "NAMES_REQUIRED": "Debes ingresar tus nombres.",
    "NAMES_PLACEHOLDER": "Ingresa tus nombres",
    "LASTNAMES_REQUIRED": "Debes ingresar tus apellidos.",
    "LASTNAMES_PLACEHOLDER": "Ingresa tus apellidos"
  }
}
